// src/components/common/Popup.jsx
import React from "react";

const Popup = ({ message, onClose }) => {
  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div
        className="bg-black bg-opacity-40 absolute inset-0"
        onClick={onClose}
      ></div>
      <div className="bg-white p-6 rounded-xl shadow-lg z-50 w-full max-w-sm text-center">
        <p className="text-lg font-semibold text-main">{message}</p>
      </div>
    </div>
  );
};

export default Popup;
